import {API} from "@/Composables/api";

const getContacts = async (params = {}) => {
    return API.get(route("contacts.index"), params);
};

const getContact = async (contact: string, params = {}) => {
    return API.get(route("contacts.show", contact), params);
};

const inviteContact = async (contact, group) => {
    return API.post(route("invitations.store"), {group}, contact);
};

const storeContact = async (formData, params = {}) => {
    return API.post(route("contacts.store"), params, formData);
};

const updateContact = async (contact, params = {}) => {
    return API.put(route("contacts.update", contact), params, contact);
};

const respondToContactInvitation = async (contact: string, response: string) => {
    return API.put(route("contacts.respond", contact), {response});
};

const deleteContact = async (contact: string) => {
    return API.delete(route("contacts.destroy", contact));
};

export {getContacts, getContact, storeContact, updateContact, respondToContactInvitation, inviteContact, deleteContact};
